// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","animate-modal":"Modal_animate-modal__zOLHA","animate-modal-mobile":"Modal_animate-modal-mobile__3SESE"};